"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOKENS = exports.ROUNDS_PER_PAGE = exports.PUT_WEEKLY_IDENTIFIER = exports.ZETA_FLEX_LOCAL_ID = exports.ZETA_FLEX_ID = exports.STRUCTURED_GENERIC_ID = exports.STRUCTURED_ID = void 0;
const web3_js_1 = require("@solana/web3.js");
exports.STRUCTURED_ID = new web3_js_1.PublicKey("1349iiGjWC7ZTbu6otFmJwztms122jEEnShKgpVnNewy");
exports.STRUCTURED_GENERIC_ID = new web3_js_1.PublicKey("7h7uYbDBZkiTvWLmMsWNAEs2VVNqfV56uSfP9hbjJMP8");
exports.ZETA_FLEX_ID = new web3_js_1.PublicKey("zFLEX6CVSPJgCwnYPYWSJFzYAC3RbP7vSoc75R88P6C");
exports.ZETA_FLEX_LOCAL_ID = new web3_js_1.PublicKey("AroWAV1Heavc5LNaL25FeGjSxqiawBMAauHsCBQYEjLi");
exports.PUT_WEEKLY_IDENTIFIER = new web3_js_1.PublicKey("4Ao5sdPbLTWru8zwtaSybiQY1R8HUXnuQqZqA2WBvwyK");
exports.ROUNDS_PER_PAGE = 128;
exports.TOKENS = {
    ETH: new web3_js_1.PublicKey("2FPyTwcZLUg1MDrwsyoP4D6s1tM7hAkHYRjkNb5w6Pxk"),
    SOL: new web3_js_1.PublicKey("So11111111111111111111111111111111111111112"),
    BTC: new web3_js_1.PublicKey("9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E"),
    MSOL: new web3_js_1.PublicKey("mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So"),
    WLUNA: new web3_js_1.PublicKey("F6v4wfAdJB8D8p77bMXZgYt8TDKsYxLYxH5AFhUkYx9W"),
    USDC: new web3_js_1.PublicKey("EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v"),
    MNGO: new web3_js_1.PublicKey("MangoCzJ36AjZyKwVj3VnYU4GTonjfVEnJmvvWaxLac"),
    FTT: new web3_js_1.PublicKey("AGFEad2et2ZJif9jaGpdMixQqvW5i81aBdvKe7PHNfz3"),
    SRM: new web3_js_1.PublicKey("SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt"),
    RAY: new web3_js_1.PublicKey("4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R"),
    STSOL: new web3_js_1.PublicKey("7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj"),
    WINJ: new web3_js_1.PublicKey("Hgtvu9gsDTzUpBn69WjrhMyzaQhrAM9piTsezmZVQP6Z"),
    SCNSOL: new web3_js_1.PublicKey("5oVNBeEEQvYi1cX3ir8Dx5n1P7pdxydbGF2X4TxVusJm"),
    SNY: new web3_js_1.PublicKey("4dmKkXNHdgYsXqBHCuMikNQWwVomZURhYvkkX5c4pQ7y"),
    WETH: new web3_js_1.PublicKey("7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs"),
    CSOL: new web3_js_1.PublicKey("5h6ssFpeDeRbzsEHDbTQNH7nVGgsKrZydxdSTnLm6QdV"),
};
